import { StyleSheet } from 'react-native';

const style = StyleSheet.create({
  container: {
    paddingVertical: 20,
    paddingHorizontal: 0
  }
})
export default style;
